import { ChangeDetectorRef, Directive, inject, Input } from '@angular/core';

@Directive()
export abstract class BaseLogoComponent {
    protected readonly cdr = inject(ChangeDetectorRef);
    private _scale: number = 1.0;

    @Input()
    get scale(): number {
        return this._scale;
    }

    set scale(value: number) {
        this._scale = value;
        this.cdr.detectChanges();
    }
}
